import API from "service";

export async function getUsersService({ signal, params }) {
  const cleanedParams = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([_, v]) => v !== "any" && v !== "" && v !== null && v !== undefined
    )
  );

  // encode search
  // Removed encodeURIComponent as axios handles this automatically and double encoding causes issues with spaces.

  const { data } = await API.get("v2/secure/dashboard/users/get-all", {
    signal,
    params: cleanedParams,
  });

  return data;
}
export async function getUsersServiceV1({ signal }) { 
  const { data } = await API.get("secure/dashboard/users/get-all", { signal }); 
  return data; 
}

export async function updateProfilePictureService({ identifier, file }) {
  let formData = new FormData();
  formData.append("data", file);

  const url = `secure/dashboard/profile-photo/${identifier}`;
  const { data } = await API.putMultipart(url, formData);
  return data;
}

export async function deleteService({ url }) {
  const { data } = await API.del(url);
  return data;
}

export async function enableAndCreateAltumPersonService(userId) {
  const { data } = await API.post(
    `/secure/altum/users/${userId}/enableAndCreate`
  );
  return data;
}
export async function disableAltumViewService(userId) {
  const { data } = await API.post(
    `/secure/altum/users/${userId}/disable`
  );
  return data;
}
export async function resendInvitationService(userId) {
  const url = `/secure/users/${userId}/resend-invitation`;
  const { data } = await API.post(url);

  return data;
}

export async function signUpService(payload) {
  const { data } = await API.post(
    "secure/admin/add-individual-thriver",
    payload
  );

  return data;
}